import {
  mdiAccount,
  mdiApps,
  mdiCalendarToday,
  mdiChartBar,
  mdiChevronDown,
  mdiChevronRight,
  mdiChevronUp,
  mdiClose,
  mdiHelpCircleOutline,
  mdiHome,
  mdiMagnify,
  mdiMapMarker,
  mdiNewspaper,
  mdiRoomService,
  mdiShopping,
  mdiSilverware,
  mdiStar,
  // eslint-disable-next-line import/no-extraneous-dependencies
} from '@mdi/js';

export const mdiSvg = {
  account: mdiAccount,
  apps: mdiApps,
  chartBar: mdiChartBar,
  calendarToday: mdiCalendarToday,
  chevronRight: mdiChevronRight,
  chevronDown: mdiChevronDown,
  chevronUp: mdiChevronUp,
  close: mdiClose,
  helpCircleOutline: mdiHelpCircleOutline,
  home: mdiHome,
  mapMarker: mdiMapMarker,
  magnify: mdiMagnify,
  newspaper: mdiNewspaper,
  roomService: mdiRoomService,
  silverware: mdiSilverware,
  shopping: mdiShopping,
  star: mdiStar,
};
